import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { nextSubmission, startSubmission } from '../../../service';
import { getUserRole } from '../../../userLocalDetails';
import {
  getLaunchContext,
  clearLaunchContext,
} from '../../../utils/ltiEmbedded';

export default function TaskDetail() {
  const { assignmentId } = useParams();
  const history = useHistory();
  
  useEffect(() => {
    const role = getUserRole();
    
    if (role === 'TEACHER') {
      nextSubmission(assignmentId)
        .then((res) => {
          if (res !== undefined && res !== null) {
            history.push(`/submissions/${res}`);
          } else {
            history.push(`/tasks/${assignmentId}`);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      const lctx = getLaunchContext();
      startSubmission(lctx ? { assignmentId, lctx } : { assignmentId })
        .then((res) => {
          if (res !== undefined && res !== null) {
            history.push(`/submissions/${res.id}`);
          } else {
            history.push('#');
          }
        })
        .catch((error) => {
          console.error(error);
          history.push('#');
        })
        .finally(() => {
          // Clear the one-time launch context regardless of outcome so a later
          // non-LTI submission of a different assignment can't reuse a stale
          // context after a failed start. No-op when nothing is stored.
          clearLaunchContext();
        });
    }
  }, [assignmentId, history]);

  return <></>;
}
